// extracted by mini-css-extract-plugin
module.exports = {"title":"Chart_title__PltvH"};